import axios from "axios";
// import { BASE_URL_USER } from "../../Utils/Constant";
import jwt_decode from "jwt-decode";
import { BASE_URL_USER } from "../App/action";

export const logoutUserApi = async (data) => {
  try {
    const res = await axios.post(`https://api.tocloudbox.io/logout`, data);
    return res;
  } catch (err) {
    return "logout";
  }
};

export const loginUserApi = async (data) => {
  try {
    const res = await axios.post(
      `${BASE_URL_USER}/public-api/v1/user/authenticate`,
      data,
      {
        withCredentials: true,
        headers: {
          "Content-Type": "application/json",
        },
      },
    );
    if (res.status === 200) {
      return res.data;
    }
  } catch (error) {
    if (error.res.status === 401) {
      console.clear("Invalid phone number: " + error.message);
    } else {
      console.clear("Something went wrong, please try again later");
    }
  }
};

export const otpUserApi = async (data) => {
  try {
    const res = await axios.post(
      `${BASE_URL_USER}/public-api/v1/OTP/validate`,
      data,
      {
        withCredentials: true,
        headers: {
          "Content-Type": "application/json",
        },
      },
    );
    if (res.status === 200) {
      return res.data;
    }
  } catch (error) {
    if (error.res.status === 401) {
      console.clear("Invalid phone number: " + error.message);
    } else {
      console.clear("Something went wrong, please try again later");
    }
  }
};
